import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { Col, breakpointsMax } from "../res/styles/Common"
import Colors from "../res/styles/Colors"
import { useTranslation } from "react-i18next"

const Container = styled.div`
    width: 400px;
    @media ${breakpointsMax.mobileL} {
        width: 100%;
    }
    text-align: center;
    color: ${Colors.red};
`

const TT = styled.div`
    font-family: "EB Garamond", serif;
    font-size: 60px;
    font-weight: 600;
`

const SB = styled.div`
    font-family: "EB Garamond", serif;
    font-size: 30px;
    font-weight: 500;
`

function Counter() {
    const [tons, setTons] = useState(0)
    const intervalRef = useRef(null)
    const { t } = useTranslation()

    useEffect(() => {
        intervalRef.current = setInterval(f, 0)
        function f() {
            if (tons === 3000) return window.clearInterval(intervalRef.current)
            setTons(tons + 3)
        }
        return () => {
            window.clearInterval(intervalRef.current)
        }
    })

    return (
        <Col>
            <Container>
                <TT>{tons}</TT>
                <SB>{t("tons")}</SB>
            </Container>
        </Col>
    )
}

export default Counter
